import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["onClick", "aria-label"]

import {reactive, ref, watch} from "vue";
import type {BTableColumn, BTableOptions} from "../BTable/BTable.types";
import {BCard} from "./../Misc";
import BTable from "../BTable/BTable.vue";
import {useNoticeStore} from "@/stores/noticeStore";
import hasPermission from "@/composable/permissionHelper";
import NoticeDetails from "../Notices/NoticeDetails.vue";
import {NoticeItem} from "../Notices/types";
import InformationModal from "../Misc/InformationModal.vue";
import {Notice} from "../../types";
import {AxiosResponse} from "axios";


export default /*@__PURE__*/_defineComponent({
  __name: 'AgencyNotice',
  props: {
    ori: {
        type: String,
        default: null,
    },
},
  setup(__props) {

const props = __props;

const tableOptions: BTableOptions = {
    itemsPerPage: Number.MAX_SAFE_INTEGER,
    page: 1,
    sortBy: [],
    totalItemCount: 0,
    pagingMode: "noTotal",
};

const columns = reactive<BTableColumn[]>([
    {
        key: "date",
        text: "Date",
        sortable: false,
        columnClass: ["align-top"],
        value: (item) => item.send_date,
    },
    {
        key: "header",
        text: "Headline",
        sortable: false,
        columnClass: ["align-top"],
        value: (item) => item.header,
    },
    {
        key: "actions",
        text: "Actions",
        sortable: false,
        columnClass: ["align-top text-end"],
        class: (item) => ["text-end"],
        value: (item) => 1,
    },
]);

const noticeStore = useNoticeStore();
var noticeDetailsModal = ref(false);
var noticeItem = ref({} as NoticeItem);
var selectedNotification = ref({} as Notice);

function handleModalDismiss() {
    noticeDetailsModal.value = false;
}

function handleViewDetailsClick(item: Notice) {
    selectedNotification.value = item;
    noticeStore.getNoticeLog(item.NotificationLogId).then((response: AxiosResponse) => {
        if (response.status == 200 && response.data != undefined) {
            noticeItem.value = response.data;
            noticeDetailsModal.value = true;
        }
    });
}

watch(props, async () => {
    if (hasPermission("NoticesMainPage")) {
        await noticeStore.list(props.ori);
    }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(NoticeDetails, {
      item: _unref(noticeItem),
      ori: props.ori,
      notification: _unref(selectedNotification),
      "show-notice-details-modal": _unref(noticeDetailsModal),
      onDismiss: handleModalDismiss,
      onSubmit: handleModalDismiss
    }, null, 8, ["item", "ori", "notification", "show-notice-details-modal"]),
    (_unref(noticeStore).items.length)
      ? (_openBlock(), _createBlock(_unref(BCard), {
          key: 0,
          header: "Notices"
        }, {
          default: _withCtx(() => [
            _createVNode(BTable, {
              items: _unref(noticeStore).items,
              columns: columns,
              caption: 'Notices List',
              "aria-label": "Notices List",
              value: tableOptions
            }, {
              "cell.actions": _withCtx(({item}) => [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-link ps-0",
                  onClick: _withModifiers(($event: any) => (handleViewDetailsClick(item)), ["prevent"]),
                  "aria-label": `View details for notice ${item.header}`
                }, " View Details ", 8, _hoisted_1)
              ]),
              _: 1
            }, 8, ["items", "columns"]),
            _cache[0] || (_cache[0] = _createElementVNode("div", { class: "text-end" }, [
              _createElementVNode("a", {
                class: "btn btn-primary",
                href: `Notices.aspx`,
                "aria-label": "View all notices"
              }, "View All")
            ], -1))
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})